Liquid = require("../liquid")

module.exports = class ElseCondition extends Liquid.Condition
  evaluate: -> true
